"use client";

import { useEffect } from "react";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

const CookieConsentClient = () => {
	useEffect(() => {
		CookieConsent.run({
			categories: {
				necessary: {
					enabled: true,
					readOnly: true,
				},
				analytics: {},
			},
			language: {
				default: "ko",
				translations: {
					ko: {
						consentModal: {
							title: "이 웹사이트는 쿠키를 사용합니다",
							description:
								"웹사이트의 원활한 운영을 위해 필수 쿠키를 사용하며, 사용자의 동의 하에 분석 및 마케팅 목적으로 선택적 쿠키를 사용합니다. 계속 진행하려면 선택을 관리하거나 모든 쿠키를 수락하세요.",
							acceptAllBtn: "모두 수락",
							acceptNecessaryBtn: "필수 항목만",
							showPreferencesBtn: "설정 관리",
						},
						preferencesModal: {
							title: "쿠키 설정 관리",
							acceptAllBtn: "모두 수락",
							acceptNecessaryBtn: "필수 항목만",
							savePreferencesBtn: "선택 저장",
							closeIconLabel: "닫기",
							sections: [
								{
									title: "쿠키 사용",
									description:
										"쿠키는 웹사이트의 기능을 향상시키고 사용자 경험을 개선하는 데 사용됩니다. 일부 쿠키는 웹사이트 운영에 필수적이며, 다른 쿠키는 분석 및 마케팅 목적으로 사용됩니다.",
								},
								{
									title: "필수 쿠키",
									description:
										"이 쿠키는 웹사이트의 핵심 기능을 활성화하는 데 필요하며, 비활성화할 수 없습니다.",
									linkedCategory: "necessary",
								},
								{
									title: "분석 쿠키",
									description:
										"이 쿠키는 웹사이트 방문자 수, 트래픽 소스 등 익명의 데이터를 수집하여 웹사이트 성능을 측정하고 개선하는 데 도움을 줍니다.",
									linkedCategory: "analytics",
								},
								{
									title: "추가 정보",
									description:
										"쿠키 정책 및 선택 사항에 대한 자세한 내용은 개인정보처리방침을 참조하십시오.",
								},
							],
						},
					},
				},
			},
		});
	}, []);

	return null;
};

export default CookieConsentClient;
